<template>
    <div class="row">
        <div class="col-12">
            <table-data
                v-validate=""
                :data="value"
                :settings="table.settings"
                :columns="table.columns"
                :inlineFilters="table.filters"
                :autoUpdateFilter="table.autoUpdateFilter"
                :addParamsToUrl="table.addParamsToUrl"
                :loadingMsg="table.loadingMsg"
                :notFoundMsg="table.notFoundMsg"
                :orderByTemplate="table.orderByTemplate"
                :showPagination="table.showPagination"
                :tableInline="table.tableInline"
                name="users"
                @error-load="showError"
            >
                <template
                    v-if="!readonlyFormItem"
                    #title
                >
                    <div class="row">
                        <div class="col-12">
                            <MaterialSelect
                                class="city-form-group city-bg"
                                size="small"
                                v-model="user"
                                label="name"
                                :ajaxOptions="{
                                    url: url.getUsers
                                }"
                                :reduce="option => option"
                            >
                                {{ $t(`${pageID}.form.placeholder_user`) }}
                                <template v-slot:option="{ option }">
                                    <strong>{{ option.name }}</strong
                                    ><br />{{ option.email }}
                                </template>
                                <template v-slot:grpAppend>
                                    <button
                                        class="btn btn-main"
                                        :disabled="!user"
                                        type="button"
                                        @click.prevent="addUser"
                                    >
                                        {{ $t(`${pageID}.form.add_user`) }}
                                    </button>
                                </template>
                            </MaterialSelect>
                        </div>
                    </div>
                </template>
                <template #body="{ row, index, remove }">
                    <td :class="table.columns[0].class">
                        {{ row.name }}
                    </td>
                    <td :class="table.columns[1].class">
                        {{ row.email }}
                    </td>
                    <column-actions
                        v-if="checkActions"
                        :deleteMsgTemplate="$t(`${pageID}.form.delete_user`, { name: row.name })"
                        :canDetail="false"
                        :canEdit="false"
                        :canDelete="canDelete"
                        :row="row"
                        :index="index"
                        :callbackDelete="remove"
                        @delete="deleteUser"
                    />
                </template>
            </table-data>
        </div>
    </div>
</template>

<script>
import mixin from '../../../../mixin';
import { formatString } from '@config/utils.js';

export default {
    components: {},
    mixins: [mixin],
    inject: {
        parentValidator: 'parentValidator'
    },
    props: {
        vScope: {
            type: String,
            default: 'form'
        },
        value: {
            type: Array,
            default: () => {
                return [];
            }
        },
        propPageID: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            autoloadItem: false,
            user: null,
            table: {
                showPagination: false,
                notFoundMsg: this.$t(`${this.propPageID}.form.user_not_found`),
                columns: [
                    {
                        label: this.$t(`${this.propPageID}.model.users.name`),
                        field: 'name',
                        sortable: false
                    },
                    {
                        label: this.$t(`${this.propPageID}.model.users.email`),
                        field: 'email',
                        sortable: false
                    },
                    {
                        label: '',
                        field: null,
                        sortable: false,
                        class: 'actions'
                    }
                ]
            }
        };
    },
    created: function () {
        this.pageID = this.propPageID;
        this.$validator = this.parentValidator;
    },
    computed: {
        getUsers() {
            return formatString(this.url.getUsers, { id: this.form.id });
        }
    },
    methods: {
        addUser: function () {
            if (!this.user) {
                return;
            }
            if (!this.value.find(u => u.id == this.user.id)) {
                this.value.unshift(this.user);
                this.user = null;

                this.forceDirtyUsers();
            }
        },
        deleteUser: function (id) {
            var removeIndex = this.value
                .map(function (user) {
                    return user.id;
                })
                .indexOf(id);
            if (removeIndex != -1) {
                this.value.splice(removeIndex, 1);

                this.forceDirtyUsers();
            }
        },
        forceDirtyUsers: function () {
            if (this.fields.$form && this.fields.$form['users']) {
                this.fields.$form['users'].dirty = true;
            }
        }
    }
};
</script>
